import React from "react";

export default function Pay() {
  return (
    <div className="text-center">
      <p className="mt-4">
        <i>Payment System will be added soon! </i>
      </p>
    </div>
  );
}
